import * as R from 'ramda';
import { CountByLodgmentType } from './redistributeCaseWithCustomDistribution';

export const getLodgmentCountFromDistribution = (distribution: CountByLodgmentType) =>
  R.pipe(R.valuesIn, R.sum)(distribution);
